import App from "./app";
import React from "react";
import { store } from "@store/store";
import { Provider } from "react-redux";
import { IntercomProvider } from 'react-use-intercom';
import Constants from "@constants/Constants";
import { ACTIS_REPORTING } from "@utils/actisReporting";

export default function Root(props) {
  const handleShowHideIntercom = (showHideValue) => () => {
    ACTIS_REPORTING.INTERCOM(showHideValue).push({
      action: Constants.ACTIS.INTERCOM.ACTION.replace(
        Constants.ACTIS.INTERCOM.DIALOG_PARAM, showHideValue
      ),
      label: Constants.ACTIS.INTERCOM.LABEL,
    });
  };

  return <Provider store={store}>
    <IntercomProvider
        appId={Constants.INTERCOM.APP_ID}
        initializeDelay={Constants.INTERCOM.TIMEOUT}
        onShow={handleShowHideIntercom(Constants.ACTIS.INTERCOM.SHOW_VALUE)}
        onHide={handleShowHideIntercom(Constants.ACTIS.INTERCOM.HIDE_VALUE)}
      >
      <App/>
    </IntercomProvider>
  </Provider>
}
